import _ from 'lodash'

import serverProps from 'transfer/utils/serverProps'

export function getServerPropsProp(prop = '') {
  return _.get(serverProps, prop)
}
